<script setup>
/** 收入趋势：收入折线（美元）+ 付费订单柱 + 退款/拒付柱，退款用 danger 色标出来。 */
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import EChart from '../EChart.vue'
import { categoryAxis, chartBase, chartTheme, valueAxis } from '../chart-theme.js'
import { useAdminTheme } from '../../composables/useAdminTheme.js'
import { formatCurrency } from '../../pages/billing/format.js'

const props = defineProps({
  items: { type: Array, required: true },
})

const emit = defineEmits(['select'])
const { t } = useI18n()
const { theme: themeName } = useAdminTheme()

const option = computed(() => {
  const theme = chartTheme(themeName.value)
  const revenue = t('visualGameAdmin.billing.dashboard.charts.revenue')
  const paidOrders = t('visualGameAdmin.billing.dashboard.charts.paidOrders')
  const refundOrders = t('visualGameAdmin.billing.dashboard.charts.refundOrders')
  return {
    ...chartBase(theme),
    color: [theme.bar, theme.info, theme.danger],
    grid: { top: 56, left: 16, right: 16, bottom: 12, containLabel: true },
    legend: { top: 8, textStyle: { color: theme.textMuted }, data: [revenue, paidOrders, refundOrders] },
    tooltip: {
      ...chartBase(theme).tooltip,
      formatter: params => [
        params[0].axisValue,
        ...params.map(item => `${item.marker} ${item.seriesName}: ${item.seriesName === revenue ? formatCurrency(item.value, 'usd') : item.value}`),
      ].join('<br>'),
    },
    xAxis: {
      ...categoryAxis(theme),
      data: props.items.map(item => item.date),
      axisLabel: { color: theme.textMuted, hideOverlap: true, formatter: value => value.slice(5) },
    },
    yAxis: [
      { ...valueAxis(theme), name: revenue, nameTextStyle: { color: theme.textMuted }, axisLabel: { color: theme.textMuted, formatter: value => formatCurrency(value, 'usd') } },
      { ...valueAxis(theme), name: paidOrders, minInterval: 1, nameTextStyle: { color: theme.textMuted } },
    ],
    series: [
      { name: revenue, type: 'line', yAxisIndex: 0, symbol: 'circle', symbolSize: 6, lineStyle: { width: 2 }, data: props.items.map(item => item.revenue_cents) },
      { name: paidOrders, type: 'bar', yAxisIndex: 1, barMaxWidth: 18, data: props.items.map(item => item.paid_orders) },
      { name: refundOrders, type: 'bar', yAxisIndex: 1, barMaxWidth: 18, data: props.items.map(item => item.refund_orders) },
    ],
  }
})
</script>

<template>
  <EChart :option="option" height="320px" @select="emit('select', props.items[$event.index])" />
</template>
